//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
      quillEditor
  } from 'vue-quill-editor'
  import ToolTip from "@/pccomponents/ToolTip";
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
    export default {
      name: "fftag",
      components: {
        quillEditor,
        ToolTip
      },
      data() {
         return {
            selectOptions:this.list,
            dropValue:'',
            editorOption: {
              modules:{
                toolbar:[
                  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                  ['blockquote', 'code-block'],
                  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                  [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                  [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                  [{ 'direction': 'rtl' }],                         // text direction
                  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                  [{ 'font': [] }],
                  [{ 'align': [] }],
                  ['clean']                                         // remove formatting button
                ]
              }
            },
         }
      },
      props:{
        //单个控件自定义的绑定规则
        rules:{
          type:Array,
          default: () => []
        },
        type:{
          type:String,
          default:""
        },
        prop:{
          type:String,
          default:""
        },
        label:{
          type:String,
          default:""
        },
        value:{
          type:null,
          default:""
        },
        placeholder:{
          type:String,
          default:""
        },
        matchItem:{
          type:String,
          default:""
        },
        editItem:{
          type:String,
          default:""
        },
        //手动控制字段是否可以编辑，默认true为可编辑
        isEdit:{
          type: Boolean,
          default: true
        },
        filterable:{
          type: Boolean,
          default: false
        },
        list:{
          type:Array,
          default: () => []
        },

        selectcode:{
          type : String,
          default:""
        },
        paras : {
          type:null,
          default: ""
        },
        hasnull:{
          type : String,
          default:"true"
        },
        //下拉框
        tagname:{
          type:String,
          default:""
        },
        showLabelToolTip: {
            type: Boolean,
            default: false
        },
        showToolTip: {
            type: Boolean,
            default: false
				},
        toolTipContent: {
            type: String,
            default: ""
        },
        //传入相应选择组件的ref,推荐都使用 ('select'+当前fftag的prop)
        selectRefName: {
            type: String,
            default: ""
        },
        minNum:{
          type: Number,
          default: -9999
        },
        maxNum:{
          type: Number,
          default:9999
        },
        pickerOptions:{
          type : Object,
          default:()=>{}
        }
      },
      created() {
        //初始化下拉框
        this.initSelect();
      },
      mounted(){
      },
      methods:{
        initSelect : function(){
          if(this.type == "select" && this.selectcode != ""){
                  var requestJsonData = []; 
                  let paramArray = {
                      showcode: "selectOptions",//存放返回的下拉框参数的变量
                      selectcode:this.selectcode,//获取查询语句
                      hasnull:this.hasnull,
                      paras:this.paras,//TOOLS为sys_cdfcodeconfig表对应的DFIELDID字段，用于填入查询语句，查出下拉数据
                  };
                  requestJsonData.push(paramArray);
                  this.initDropDown(this,requestJsonData);   
           }
        },
        /**
         * 当input为选择框时，添加点击事件关联选择框
         */
        selectOption : function(){
          if(this.selectRefName!=''){
            let currComponent=this.findComponentUpward(this.$parent);
            currComponent.$refs['selectIcon'].click();
          }
        },
        /**
         * 递归获取选择框组件
         */
        findComponentUpward : function(currComponent){
          if(this.isNotNullOrEmpty(currComponent.$refs[this.selectRefName])){
            return currComponent.$refs[this.selectRefName];
          }else{
            return this.findComponentUpward(currComponent.$parent)
          }
        },
        /**
         * 下拉框提示信息
         */
        getMainSelTitleTip: function(val){
          if (val != ""){
            let result = this.getSelectOptions.filter(elmt => elmt.propertyValue === val)
            if (result.length > 0 && result[0].hasOwnProperty("tips") && this.isNotNullOrEmpty(result[0].tips)){
                return result[0].tips
            }
          }
        }
      },
      computed: {
        timeFormate:function(){
          var sysname = process.env.SYS_NAME;
           let currvalue = this.value;
          if(sysname != 'HR' || currvalue == null || currvalue == ''){
             return "dd-MM-yyyy"
          }
          let month = currvalue.split("-")[1];
          let f_month = "";
          switch(month) {
            case '01' : f_month = "Jan"; break;
            case '02' : f_month = "Feb"; break;
            case '03' : f_month = "Mar"; break;
            case '04' : f_month = "Apr"; break;
            case '05' : f_month = "May"; break;
            case '06' : f_month = "Jun"; break;
            case '07' : f_month = "Jul"; break;
            case '08' : f_month = "Aug"; break;
            case '09' : f_month = "Sept"; break;
            case '10' : f_month = "Oct"; break;
            case '11' : f_month = "Nov"; break;
            case '12' : f_month = "Dec"; break;
            default:   f_month = "MM"; break;

          }
          return "dd-'"+f_month+"'-yyyy"
        },
        readonly: function () {

          if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
            //返回true,设为只读
            return true;
          }else{
            return false;
          }
        },
        getSelectOptions : function (){  
            if(this.list != ""){
              if (this.list.length == 1 && !this.readonly){ 
                this.$emit('input',this.list[0].propertyValue)
              }
              return this.list;
            }
            if (this.selectOptions.length == 1 && !this.readonly){
              this.$emit('input',this.selectOptions[0].propertyValue)
            }
            return this.selectOptions;
        },
        getSelectLabel:function(){
          let selectLabel = '';
          for(let item of this.getSelectOptions){
            let val = item.propertyValue;
            if(val === this.value && this.isNotNullOrEmpty(val)){
              selectLabel = item.propertyLabel;
              break;
            }
          }
          return selectLabel;
        },
        ininMoney:function()
        {
          let moneyval="";
           if(this.type == "money" )
           {
             //let reg = /(\d)(?=(?:\d{4})+$)/g;
             moneyval= this.commaFy(this.value);
           }
           return moneyval;
        } ,
        
        checkboxData:{
          get:function(){
            if(this.value==''){
              return [];
            }else{
              return this.value;
            }
          },
          set:function(val){
            this.$emit('input',val)
          }
        },
        currentvalue:{
          get:function(){
            return this.value;
          },
          set:function(val){
            this.$emit('input',val)
          }
        },
        vHtmlTextArea:function(){
          let textAreaContent = "";
          //段落的换行、空格
          textAreaContent = this.value.replace(/\n/g,'<br/>').replace(/ /g,'&nbsp');;
          return textAreaContent;
        }
      },
      // filters:{
      //   //时间格式化
      //   filterDate:function(value){
      //     if(!value) return '';
      //     let day = value.split("-")[0];
      //     let month = value.split("-")[1];
      //     let year = value.split("-")[2];
      //     let f_month = "";
      //     switch(month) {
      //       case '01' : f_month = "Jan"; break;
      //       case '02' : f_month = "Feb"; break;
      //       case '03' : f_month = "Mar"; break;
      //       case '04' : f_month = "Apr"; break;
      //       case '05' : f_month = "May"; break;
      //       case '06' : f_month = "Jun"; break;
      //       case '07' : f_month = "Jul"; break;
      //       case '08' : f_month = "Aug"; break;
      //       case '09' : f_month = "Sept"; break;
      //       case '10' : f_month = "Oct"; break;
      //       case '11' : f_month = "Nov"; break;
      //       case '12' : f_month = "Dec"; break;
      //       default:   f_month = "MM"; break;

      //     }
      //     return day+"-"+f_month+"-"+year;
      //   }
      // }
    }



// WEBPACK FOOTER //
// ./src/pccomponents/fftag.vue